// ngx-mat-timepicker-patch.ts

import { NgxMatTimepickerComponent } from '@angular-material-components/datetime-picker';

export function overRideNgxMatTimepicker() {
    // Check if the NgxMatTimepickerComponent is available
    /**
     * Patches the `writeValue` function of `NgxMatTimepickerComponent`.
     * 
     * This patch modifies the `writeValue` method of `NgxMatTimepickerComponent` to:
     * 1. If a value is provided (`val != null`), it sets the model (`_model`) to the given value.
     * 2. If the value is `null`, it sets the model to the current date using `_dateAdapter.today()`.
     *    - Additionally, if a default time is specified (`defaultTime != null`), it applies that default time to the model using `_dateAdapter.setTimeByDefaultValues()`.
     * 3. After updating the model, it calls `_updateHourMinuteSecond()` to ensure the internal state is correctly updated.
     * 4. Finally, it triggers `form.updateValueAndValidity()` asynchronously via `setTimeout()` to ensure the form's validity is updated after the model is changed.
     * 
     * This patch is applied globally to ensure that `NgxMatTimepickerComponent` handles its value updates in a consistent way, particularly when no value is provided.
     * 
     * **Why This Modification is Necessary**:
     * The original `writeValue` function of `NgxMatTimepickerComponent` may not handle cases where `null` or `undefined` is passed correctly, or it might not apply default time values in a way that fits the application's requirements. This patch ensures a default time is applied when necessary and handles null values gracefully.
     */

    if (NgxMatTimepickerComponent) {
        NgxMatTimepickerComponent.prototype.writeValue = function (val: any): void {
            if (val != null) {
                this._model = val;
            } else {
                this._model = this._dateAdapter.today();
                if (this.defaultTime != null) {
                    this._dateAdapter.setTimeByDefaultValues(this._model, this.defaultTime);
                }
            }
            this._updateHourMinuteSecond();
            setTimeout(() => {
                this.form.updateValueAndValidity();
            });
        };
    }
}
